let idModelo = null;
let totalPreguntas = 0; // número de preguntas renderizadas
let dispositivoSeleccionado = null;
let identificadorActual = '';
let ultimaCotizacion = null;
let preguntasValoracionActuales = [];

function limpiarValoracion() {
    document.getElementById('gradingQuestions').innerHTML = '';
    document.getElementById('quotedPrice').innerText = '';
    document.getElementById('deviceCard').style.display = 'none';
    document.getElementById('errorMessage').innerText = '';
    dispositivoSeleccionado = null;
    identificadorActual = '';
    ultimaCotizacion = null;
    preguntasValoracionActuales = [];
}

function identificadorValido(valor) {
    const imeiRegex = /^\d{15}$/;
    const serial10 = /^[A-Z0-9]{10}$/i;
    const serial12 = /^[A-Z0-9]{12}$/i;
    return imeiRegex.test(valor) || serial10.test(valor) || serial12.test(valor);
}

function ibanLongitudValida(valor) {
    const iban = String(valor || '').replace(/\s+/g, '').toUpperCase();
    if (!iban) return true;

    const longitudesPorPais = {
        AL: 28, AD: 24, AT: 20, AZ: 28, BE: 16, BH: 22, BA: 20, BR: 29,
        BG: 22, CR: 22, HR: 21, CY: 28, CZ: 24, DK: 18, DO: 28, EE: 20,
        FO: 18, FI: 18, FR: 27, GE: 22, DE: 22, GI: 23, GR: 27, GL: 18,
        GT: 28, HU: 28, IS: 26, IE: 22, IL: 23, IT: 27, JO: 30, KZ: 20,
        XK: 20, KW: 30, LV: 21, LB: 28, LI: 21, LT: 20, LU: 20, MT: 31,
        MR: 27, MU: 30, MC: 27, MD: 24, ME: 22, NL: 18, MK: 19, NO: 15,
        PK: 24, PS: 29, PL: 28, PT: 25, QA: 29, RO: 24, SM: 27, SA: 24,
        RS: 22, SK: 24, SI: 19, ES: 24, SE: 24, CH: 21, TN: 24, TR: 26,
        AE: 23, GB: 22, VG: 24
    };

    const codigoPais = iban.slice(0, 2);
    const longitudEsperada = longitudesPorPais[codigoPais];

    if (!longitudEsperada) {
        return iban.length >= 15 && iban.length <= 34;
    }

    return iban.length === longitudEsperada;
}

function normalizarUrl(u) {
    if (!u) return '';
    if (/^\/\//.test(u)) return 'https:' + u;
    return u;
}

function setLoadingBusqueda(estaCargando) {
    const cargaEl = document.getElementById('carga');
    const botonBuscar = document.getElementById('buscarBtn');
    if (cargaEl) {
        cargaEl.style.display = 'none';
    }
    if (botonBuscar) {
        if (!botonBuscar.dataset.originalText) {
            botonBuscar.dataset.originalText = botonBuscar.textContent.trim();
        }
        botonBuscar.disabled = estaCargando;
        if (estaCargando) {
            botonBuscar.classList.add('is-loading');
            botonBuscar.innerHTML = '<span class="spinner button-spinner" aria-hidden="true"></span><span>Buscando...</span>';
        } else {
            botonBuscar.classList.remove('is-loading');
            botonBuscar.textContent = botonBuscar.dataset.originalText || 'Buscar Dispositivo';
        }
    }
}

function esperarRenderSpinner() {
    return new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve));
    });
}

// Primera búsqueda del dispositivo por IMEI o número de serie, muestra datos básicos y luego permite empezar valoración
async function buscarDispositivo() {
    document.getElementById('gradingQuestions').innerHTML = '';
    document.getElementById('grading').style.display = 'none';
    const errorEl = document.getElementById('errorMessage');
    errorEl.innerText = '';
    idModelo = null;
    const identificador = document.getElementById("identifier").value.replace(/\s/g, '');
    if (!identificador) {
        errorEl.innerText = 'Por favor, introduce un IMEI o número de serie para realizar la búsqueda.';
        return;
    }
    if (!identificadorValido(identificador)) {
        errorEl.innerText = 'Introduce un IMEI o número de serie válido antes de buscar.';
        return;
    }
    identificadorActual = identificador;
    const inicioCarga = performance.now();
    setLoadingBusqueda(true);
    await esperarRenderSpinner();
    try {
        const url = `https://n8n.rossellimac.info/webhook/get-modelid?identifier=${encodeURIComponent(identificador)}`;
        const response = await fetch(url, { method: "GET" });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        if (!data.Data || data.Data.length === 0) throw new Error('Dispositivo no encontrado');
        const dispositivo = data.Data[0];
        idModelo = dispositivo.Id;
        dispositivoSeleccionado = dispositivo;
        precioDispositivo = dispositivo.Price - 20;
        document.getElementById("deviceName").innerText = dispositivo.ItemName;
        document.getElementById("devicePrice").innerText = "Precio estimado: " + precioDispositivo + " " + dispositivo.CurrencySymbol;
        // Mostrar PictureUrl si existe, si no ImageUrl
        const pictureUrl = dispositivo.PictureUrl ? dispositivo.PictureUrl : dispositivo.ImageUrl;
        document.getElementById("deviceImage").src = normalizarUrl(pictureUrl);
        // document.getElementById("modelId").innerText = dispositivo.Id;
        document.getElementById('deviceCard').style.display = 'flex';
    } catch (error) {
        idModelo = null;
        dispositivoSeleccionado = null;
        errorEl.innerText = 'No hemos encontrado un dispositivo con ese IMEI o número de serie. Por favor, verifica el dato ingresado e inténtalo nuevamente.';
        console.error('buscarDispositivo error', error);
    } finally {
        const tiempoMinimoVisible = 300;
        const tiempoTranscurrido = performance.now() - inicioCarga;
        if (tiempoTranscurrido < tiempoMinimoVisible) {
            await new Promise((resolve) => setTimeout(resolve, tiempoMinimoVisible - tiempoTranscurrido));
        }
        setLoadingBusqueda(false);
    }
}

async function empezarValoracion() {
    const errorEl = document.getElementById('errorMessage');
    errorEl.innerText = '';
    if (!idModelo) {
        errorEl.innerText = 'No hay modelo seleccionado.';
        return;
    }
    try {
        const url = `https://n8n.rossellimac.info/webhook/get-questions?modelId=${encodeURIComponent(idModelo)}`;
        const response = await fetch(url, { method: "GET" });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const text = await response.text();
        const data = JSON.parse(text);
        renderPreguntasValoracion(data);
        // Scroll automático a las preguntas
        setTimeout(() => {
            const preguntas = document.getElementById('gradingQuestions');
            if (preguntas) {
                preguntas.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 200);
    } catch (err) {
        errorEl.innerText = 'Error al obtener la valoración.';
        console.error('error valoracion', err);
    }
}

function renderPreguntasValoracion(data) {
    const contenedor = document.getElementById('gradingQuestions');
    contenedor.innerHTML = '';
    contenedor.style.display = 'block';
    document.getElementById('quotedPrice').innerText = '';
    for (const k in respuestasValoracion) delete respuestasValoracion[k];
    totalPreguntas = 0;
    let preguntas = [];
    if (Array.isArray(data.Questions)) {
        data.Questions.forEach((q, qi) => {
            const tarjetas = Array.isArray(q.InfoCards) && q.InfoCards.length ? q.InfoCards : [{ Text: q.Info || '', Images: [] }];
            tarjetas.forEach((tarjeta, ci) => {
                preguntas.push({
                    name: q.Name || 'Pregunta sin texto',
                    text: tarjeta.Text || '',
                    images: tarjeta.Images || [],
                    answers: q.Answers || []
                });
            });
        });
    } else {
        function extraerTexto(obj) {
            if (!obj || typeof obj !== 'object') return null;
            for (const key of Object.keys(obj)) {
                if (/question/i.test(key) || /text/i.test(key)) {
                    return obj[key];
                }
            }
            return null;
        }
        data.forEach((qObj) => {
            const infoCards = qObj.InfoCards || [];
            infoCards.forEach((card) => {
                preguntas.push({
                    name: extraerTexto(qObj) || 'Sin texto',
                    text: extraerTexto(card) || '',
                    images: card.Images || [],
                    answers: [{ Name: 'Si' }, { Name: 'No' }]
                });
            });
        });
    }
    preguntasValoracionActuales = preguntas;
    totalPreguntas = preguntas.length;
    let indiceActual = 0;
    function renderCarruselPregunta(idx) {
        contenedor.innerHTML = '';
        const pregunta = preguntas[idx];
        const cardDiv = document.createElement('div');
        cardDiv.className = 'grading-question';
        const rowDiv = document.createElement('div');
        rowDiv.className = 'grading-question-row';
        const textCol = document.createElement('div');
        textCol.className = 'question-col';
        const pq = document.createElement('div');
        pq.innerHTML = pregunta.name;
        textCol.appendChild(pq);
        if (pregunta.text) {
            const txt = document.createElement('div');
            txt.innerHTML = pregunta.text;
            textCol.appendChild(txt);
        }
        const imgsCol = document.createElement('div');
        imgsCol.className = 'images-col';
        if (pregunta.images && pregunta.images.length) {
            // Botón pequeño para mostrar ejemplos
            const btnEjemplo = document.createElement('button');
            btnEjemplo.textContent = 'Ver ejemplos';
            btnEjemplo.style.padding = '3px 10px';
            btnEjemplo.style.fontSize = '0.85em';
            btnEjemplo.style.margin = '8px 0';
            btnEjemplo.style.borderRadius = '12px';
            btnEjemplo.style.background = '#e6eaff';
            btnEjemplo.style.color = '#3f70df';
            btnEjemplo.style.border = '1px solid #bfcfff';
            btnEjemplo.style.cursor = 'pointer';
            btnEjemplo.style.boxShadow = 'none';
            imgsCol.appendChild(btnEjemplo);

            // Modal carrusel
            btnEjemplo.onclick = () => {
                let imgIndex = 0;
                // Crear modal
                let modal = document.createElement('div');
                modal.style.position = 'fixed';
                modal.style.top = '0';
                modal.style.left = '0';
                modal.style.width = '100vw';
                modal.style.height = '100vh';
                modal.style.background = 'rgba(0,0,0,0.93)';
                modal.style.display = 'flex';
                modal.style.flexDirection = 'column';
                modal.style.justifyContent = 'center';
                modal.style.alignItems = 'center';
                modal.style.zIndex = '2000';

                // Imagen grande
                const imgTag = document.createElement('img');
                imgTag.src = normalizarUrl(pregunta.images[imgIndex]);
                imgTag.style.maxWidth = '90vw';
                imgTag.style.maxHeight = '70vh';
                imgTag.style.borderRadius = '10px';
                imgTag.style.boxShadow = '0 2px 12px rgba(0,0,0,0.25)';
                imgTag.style.marginBottom = '18px';

                // Carrusel siempre visible si hay más de una imagen
                const navDiv = document.createElement('div');
                navDiv.style.display = 'flex';
                navDiv.style.justifyContent = 'center';
                navDiv.style.alignItems = 'center';
                navDiv.style.gap = '32px';

                const prevBtn = document.createElement('span');
                prevBtn.innerHTML = '&#8592;';
                prevBtn.style.fontSize = '2.2em';
                prevBtn.style.cursor = 'pointer';
                prevBtn.style.opacity = '1';
                prevBtn.style.color = '#fff';
                prevBtn.style.textShadow = '0 2px 8px #222, 0 0 2px #fff';
                prevBtn.onclick = (e) => {
                    e.stopPropagation();
                    if (imgIndex > 0) {
                        imgIndex--;
                        imgTag.src = normalizarUrl(pregunta.images[imgIndex]);
                    }
                };

                const nextBtn = document.createElement('span');
                nextBtn.innerHTML = '&#8594;';
                nextBtn.style.fontSize = '2.2em';
                nextBtn.style.cursor = 'pointer';
                nextBtn.style.opacity = '1';
                nextBtn.style.color = '#fff';
                nextBtn.style.textShadow = '0 2px 8px #222, 0 0 2px #fff';
                nextBtn.onclick = (e) => {
                    e.stopPropagation();
                    if (imgIndex < pregunta.images.length - 1) {
                        imgIndex++;
                        imgTag.src = normalizarUrl(pregunta.images[imgIndex]);
                    }
                };

                navDiv.appendChild(prevBtn);
                navDiv.appendChild(nextBtn);

                // Cerrar modal
                const closeBtn = document.createElement('span');
                closeBtn.innerHTML = '&times;';
                closeBtn.style.position = 'absolute';
                closeBtn.style.top = '0';
                closeBtn.style.right = '-48px';
                closeBtn.style.fontSize = '2.2em';
                closeBtn.style.color = '#fff';
                closeBtn.style.cursor = 'pointer';
                closeBtn.style.zIndex = '2100';
                closeBtn.style.background = 'rgba(0,0,0,0.25)';
                closeBtn.style.borderRadius = '50%';
                closeBtn.style.padding = '2px 10px 2px 10px';
                closeBtn.onclick = (e) => {
                    e.stopPropagation();
                    document.body.removeChild(modal);
                };

                modal.onclick = () => {
                    document.body.removeChild(modal);
                };

                // Envoltorio para imagen y X
                const imgWrap = document.createElement('div');
                imgWrap.style.position = 'relative';
                imgWrap.style.display = 'inline-block';
                imgWrap.style.verticalAlign = 'top';
                imgWrap.appendChild(imgTag);
                imgWrap.appendChild(closeBtn);
                // Ajustar el ancho del imgWrap al de la imagen
                imgTag.onload = function () {
                    imgWrap.style.width = imgTag.width + 'px';
                };
                modal.appendChild(imgWrap);
                if (pregunta.images.length > 1) modal.appendChild(navDiv);
                document.body.appendChild(modal);
            };
        }
        rowDiv.appendChild(textCol);
        rowDiv.appendChild(imgsCol);
        cardDiv.appendChild(rowDiv);
        const btnDiv = document.createElement('div');
        btnDiv.className = 'answer-buttons';
        btnDiv.style.justifyContent = 'center';
        btnDiv.style.display = 'flex';
        btnDiv.style.gap = '10px';
        // Recuperar respuesta guardada
        const respuestaGuardada = respuestasValoracion[idx];
        pregunta.answers.forEach((ans, i) => {
            const btn = document.createElement('button');
            btn.textContent = ans.Name;
            btn.onclick = () => {
                seleccionarRespuesta(idx, mapearValorRespuesta(ans), btn, btnDiv, true);
            };
            // Si la respuesta guardada coincide, marcar como seleccionada
            if (respuestaGuardada !== undefined && mapearValorRespuesta(ans) === respuestaGuardada) {
                btn.classList.add('selected');
            }
            btnDiv.appendChild(btn);
        });
        cardDiv.appendChild(btnDiv);
        // Navegación
        const navDiv = document.createElement('div');
        navDiv.style.display = 'flex';
        navDiv.style.justifyContent = 'space-between';
        navDiv.style.marginTop = '18px';
        navDiv.style.gap = '10px';
        // Navegación tipo puntos con flechas
        navDiv.style.display = 'block';
        navDiv.style.width = '100%';
        navDiv.style.margin = '0 auto';
        navDiv.style.textAlign = 'center';
        navDiv.style.height = '32px';
        navDiv.style.minHeight = '32px';
        navDiv.style.gap = '0';

        // Envoltorio para centrar flechas y puntos
        const navInner = document.createElement('div');
        navInner.style.display = 'flex';
        navInner.style.justifyContent = 'center';
        navInner.style.alignItems = 'center';

        const flechaIzq = document.createElement('span');
        flechaIzq.innerHTML = '&#8592;';
        flechaIzq.style.cursor = idx > 0 ? 'pointer' : 'default';
        flechaIzq.style.fontSize = '1.3rem';
        flechaIzq.style.marginRight = '12px';
        flechaIzq.style.userSelect = 'none';
        flechaIzq.style.opacity = idx > 0 ? '1' : '0.3';
        flechaIzq.style.display = 'flex';
        flechaIzq.style.alignItems = 'center';
        if (idx > 0) {
            flechaIzq.onclick = () => {
                indiceActual--;
                renderCarruselPregunta(indiceActual);
            };
        }

        const puntosDiv = document.createElement('div');
        puntosDiv.style.display = 'flex';
        puntosDiv.style.alignItems = 'center';
        puntosDiv.style.gap = '6px';
        for (let i = 0; i < preguntas.length; i++) {
            const punto = document.createElement('span');
            punto.style.width = '8px';
            punto.style.height = '8px';
            punto.style.borderRadius = '50%';
            punto.style.display = 'inline-block';
            punto.style.background = i === idx ? '#3f70df' : '#cfd8e3';
            punto.style.border = i === idx ? '2px solid #3f70df' : '2px solid #cfd8e3';
            punto.style.transition = 'background 0.2s, border 0.2s';
            punto.style.cursor = 'pointer';
            punto.onclick = () => {
                indiceActual = i;
                renderCarruselPregunta(indiceActual);
            };
            puntosDiv.appendChild(punto);
        }

        const flechaDer = document.createElement('span');
        flechaDer.innerHTML = '&#8594;';
        flechaDer.style.cursor = idx < preguntas.length - 1 ? 'pointer' : 'default';
        flechaDer.style.fontSize = '1.3rem';
        flechaDer.style.marginLeft = '12px';
        flechaDer.style.userSelect = 'none';
        flechaDer.style.opacity = idx < preguntas.length - 1 ? '1' : '0.3';
        flechaDer.style.display = 'flex';
        flechaDer.style.alignItems = 'center';
        if (idx < preguntas.length - 1) {
            flechaDer.onclick = () => {
                indiceActual++;
                renderCarruselPregunta(indiceActual);
            };
        }

        navInner.appendChild(flechaIzq);
        navInner.appendChild(puntosDiv);
        navInner.appendChild(flechaDer);
        navDiv.appendChild(navInner);
        navInner.style.display = 'inline-flex';
        cardDiv.appendChild(navDiv);
        contenedor.appendChild(cardDiv);
    }
    renderCarruselPregunta(indiceActual);
    // Modificar seleccionarRespuesta para avanzar automáticamente
    window._avanzarCarruselPregunta = function (idx) {
        if (idx < preguntas.length - 1) {
            indiceActual = idx + 1;
            renderCarruselPregunta(indiceActual);
        }
    }
}

async function seleccionarRespuesta(indicePregunta, valor, elementoBoton, contenedorBotones) {
    respuestasValoracion[indicePregunta] = valor;
    const hermanos = contenedorBotones.querySelectorAll('button');
    hermanos.forEach(b => b.classList.remove('selected'));
    elementoBoton.classList.add('selected');
    // Solo mostrar precio cuando todas las preguntas estén respondidas
    const respondidas = Object.keys(respuestasValoracion).length;
    if (respondidas === totalPreguntas && totalPreguntas > 0) {
        enviarCotizacion();
    } else {
        document.getElementById('quotedPrice').innerText = '';
    }
    // Si es modo carrusel, avanzar automáticamente
    if (typeof window._avanzarCarruselPregunta === 'function') {
        window._avanzarCarruselPregunta(indicePregunta);
    }
}

const respuestasValoracion = {}; // almacena 0/1

function mapearValorRespuesta(ans) {
    if (!ans || !ans.Name) return 1;
    const txt = ans.Name.toLowerCase();
    if (/sí|si|yes|true/.test(txt)) return 0;
    return 1;
}

async function enviarCotizacion() {
    if (!idModelo) return;
    const respuestasPayload = {};
    for (const idx in respuestasValoracion) {
        if (respuestasValoracion[idx] != null) {
            const numKey = parseInt(idx, 10);
            respuestasPayload[numKey] = [respuestasValoracion[idx]];
        }
    }
    const payload = {
        GradingForm: {
            Answers: respuestasPayload,
            Extras: [0],
            SystemExtras: [0],
            GradingDifferenceImages: {}
        },
        ModelId: idModelo,
        ItemIdentifier: null,
        LocationId: null,
        AgentId: null,
        TradeInChannel: 0,
        TradeInType: 0,
        CampaignId: null
    };
    try {
        const resp = await fetch('https://n8n.rossellimac.info/webhook/send-questions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        const text = await resp.text();
        if (!resp.ok) {
            const errMsg = 'Cotización fallida: ' + resp.status + ' ' + resp.statusText + '\n' + text;
            document.getElementById('errorMessage').innerText = errMsg;
            document.getElementById('quotedPrice').innerText = '';
            return;
        }
        let data;
        try { data = JSON.parse(text); } catch (e) {
            console.error('Error parsing JSON:', text);
            return;
        }

        if (Array.isArray(data) && data.length > 0) {
            data = data[0];
        }
        // Mapear campos: soportar tanto el formato antiguo (OfferedPrice/CurrencySymbol) como el nuevo (price/currencySymbol)
        const precio = data.price ?? data.OfferedPrice ?? null;
        const moneda = data.currencySymbol || data.CurrencySymbol || data.currency || data.CurrencyIsoCode || data["د.إ"] || '';
        ultimaCotizacion = {
            offeredPrice: precio,
            currency: moneda,
            apiResponse: data,
            gradingAnswers: obtenerResumenValoracion()
        };
        if (precio != null) {

            const quotedEl = document.getElementById("quotedPrice");
            quotedEl.textContent = '';
            quotedEl.insertAdjacentHTML('beforeend', `<div style='font-size:30px;'><b>Precio cotizado:</b> ${precio} ${moneda}*</div><div class='legal-note' style='margin-top:10px; font-size:10px; color:#555;'>* Esta cotización es orientativa y está pendiente de revisión por nuestro personal. El valor final puede variar tras la inspección física del dispositivo.</div>`);
            // Eliminar acciones previas si existían
            const prevActions = document.getElementById('quoteActions');
            if (prevActions) prevActions.remove();
            // Añadir botones de acción: Enviar a tienda y Entregar a tienda
            const actions = document.createElement('div');
            actions.id = 'quoteActions';
            actions.style.marginTop = '12px';
            actions.style.display = 'flex';
            actions.style.gap = '10px';
            actions.style.justifyContent = 'center';
            actions.style.width = '100%';

            const btnEmpezarTradeIn = document.createElement('button');
            btnEmpezarTradeIn.textContent = 'Comenzar Renove';
            btnEmpezarTradeIn.className = 'start-button';
            // Abrir el panel lateral con el formulario al empezar Trade-In
            // Usar ultimaCotizacion como fallback para asegurar que precio y moneda existan
            const precioFinal = precio ?? ultimaCotizacion?.offeredPrice ?? '—';
            const monedaFinal = moneda || ultimaCotizacion?.currency || '';
            btnEmpezarTradeIn.onclick = () => openSideForm(precioFinal, monedaFinal);

            actions.appendChild(btnEmpezarTradeIn);
            quotedEl.appendChild(actions);

            // Scroll automático al precio cotizado
            setTimeout(() => {
                const quoted = document.getElementById('quotedPrice');
                if (quoted) quoted.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 200);
        } else {
            // Si no hay precio, eliminar acciones previas
            const prevActions = document.getElementById('quoteActions');
            if (prevActions) prevActions.remove();
        }
        const errEl = document.getElementById('errorMessage');
        if (errEl) errEl.innerText = '';
    } catch (err) {
        const errMsg = 'Error de cotización: ' + (err.message || err);
        document.getElementById('errorMessage').innerText = errMsg;
        document.getElementById('quotedPrice').innerText = '';
        const prevActions = document.getElementById('quoteActions'); if (prevActions) prevActions.remove();
    }
}

function obtenerResumenValoracion() {
    return preguntasValoracionActuales.reduce((acumulado, pregunta, indice) => {
        const valorGuardado = respuestasValoracion[indice];
        if (valorGuardado == null) return acumulado;

        const respuestaSeleccionada = Array.isArray(pregunta.answers)
            ? pregunta.answers.find((ans) => mapearValorRespuesta(ans) === valorGuardado)
            : null;

        acumulado.push({
            indice: indice,
            pregunta: pregunta.name || '',
            detalle: pregunta.text || '',
            respuesta: respuestaSeleccionada ? respuestaSeleccionada.Name : String(valorGuardado),
            valorRespuesta: valorGuardado
        });
        return acumulado;
    }, []);
}

function obtenerPropiedadPorAlias(objeto, aliases) {
    if (!objeto || typeof objeto !== 'object') return '';

    const entries = Object.entries(objeto);
    for (const alias of aliases) {
        const aliasNormalizado = alias.toLowerCase();
        const match = entries.find(([clave]) => clave.toLowerCase() === aliasNormalizado);
        if (match && match[1] != null && String(match[1]).trim()) {
            return String(match[1]).trim();
        }
    }

    return '';
}

function esObjetoTienda(objeto) {
    if (!objeto || typeof objeto !== 'object' || Array.isArray(objeto)) return false;

    const claves = Object.keys(objeto).map((clave) => clave.toLowerCase());
    return claves.includes('centro')
        || claves.includes('direccion')
        || claves.includes('idcentro')
        || claves.includes('name')
        || claves.includes('address');
}

function normalizarTiendas(payload) {
    const resultado = [];

    function visitar(nodo) {
        if (!nodo) return;

        if (Array.isArray(nodo)) {
            nodo.forEach(visitar);
            return;
        }

        if (typeof nodo !== 'object') return;

        if (esObjetoTienda(nodo)) {
            resultado.push(nodo);
            return;
        }

        Object.values(nodo).forEach(visitar);
    }

    visitar(payload);
    return resultado;
}

async function cargarTiendas(selectEl) {
    if (!selectEl) return;

    selectEl.disabled = true;
    selectEl.innerHTML = '<option value="">Cargando tiendas...</option>';

    try {
        const response = await fetch('https://n8n.rossellimac.info/webhook/get-stores', { method: 'GET' });
        if (!response.ok) throw new Error('HTTP ' + response.status);

        const payload = await response.json();
        const tiendas = normalizarTiendas(payload);

        if (!tiendas.length) {
            selectEl.innerHTML = '<option value="">No hay tiendas disponibles</option>';
            return;
        }

        selectEl.innerHTML = '<option value="">Selecciona una tienda</option>';

        tiendas.forEach((tienda, index) => {
            const nombre = tienda.Centro;
            const direccion = tienda.Direccion;
            const codigoPostal = tienda.CP;
            const id = obtenerPropiedadPorAlias(tienda, ['idCentro', 'id', 'storeId', 'identifier']);
            const option = document.createElement('option');

            option.value = id;
            option.textContent = `${nombre} - ${direccion} (${codigoPostal})`;

            option.dataset.name = nombre;
            option.dataset.address = direccion;
            option.dataset.postalCode = codigoPostal;
            option.dataset.id = id;

            selectEl.appendChild(option);
        });

        selectEl.disabled = false;
    } catch (error) {
        selectEl.innerHTML = '<option value="">No se pudieron cargar las tiendas</option>';
        console.error('Error cargando tiendas desde n8n', error);
    }
}

// Mostrar formulario como modal emergente (pop-up)
async function openSideForm(precio, moneda) {
    const modal = document.getElementById('tradeInModal');
    modal.innerHTML = `
                <div class="tradein-box" role="dialog" aria-modal="true" onclick="event.stopPropagation()">
                    <button class="close-btn" aria-label="Cerrar" onclick="closeTradeInModal(event)">&times;</button>
                    <h3 style="margin-top:0">Formulario de Renove</h3>
                    <p style="font-size:30px;color:green;margin-top:0;margin-bottom:0;">Precio cotizado: <b>${precio} ${moneda || ''}*</b></p>
                    <p style="font-size:10px;color:#555;margin-top:0;margin-bottom:30px;">* El precio final está sujeto a revisión tras la inspección física del dispositivo.</p>
                    <form id="tradeInForm">
                        <label>Nombre completo*</label>
                        <input name="nombre" type="text" required />
                        <label>DNI/NIE*</label>
                        <input name="dni" type="text" required />
                        <label>Email*</label>
                        <input name="email" type="email" required />
                        <label>Teléfono*</label>
                        <input name="telefono" type="tel" inputmode="numeric" pattern="[0-9]+" required />
                        <div class="radio-row">
                            <label class="radio"><input type="radio" name="tradeinOption" id="envio" value="envio" required />Envío</label>
                            <label class="radio"><input type="radio" name="tradeinOption" id="entregaTienda" value="entrega" required />Entrega en tienda</label>
                        </div>
                        <div id="facturaField" style="display:none; margin-top:3px;">
                            <label>Factura de compra*</label>
                            <p style="font-size:10px;color:#555;margin-top:0;">Para poder abonarle la cotización del dispositivo que nos va a enviar (pendiente de revisión), tiene que haber comprado en los últimos 7 días un dispositivo nuevo en nuestra tienda web. Indique el número de factura.</p>
                            <input name="factura" type="text" placeholder="Número de factura" required />
                            <label>Direccion*</label>
                            <input name="direccion" type="text" placeholder="Dirección de recogida" required />
                            <label>Código Postal*</label>
                            <input name="codigoPostal" type="text" placeholder="Código Postal" required />
                            <label>Número IBAN*</label>
                            <input name="iban" type="text" placeholder="Número IBAN donde se realizará la devolución del importe" required />
                        </div>
                        <label>Tienda destino*</label>
                        <select name="tienda" required>
                            <option value="">Selecciona una tienda</option>
                        </select>
                        
                        <input name="precioCotizado" type="hidden" value="${precio}" />
                        <input name="monedaCotizada" type="hidden" value="${moneda || ''}" />
                        <div style="margin-top:8px;display:flex;gap:8px;justify-content:center;">
                            <button type="submit" class="start-button">Enviar solicitud</button>
                            <button type="button" class="start-button" onclick="closeTradeInModal()">Cancelar</button>
                        </div>
                    </form>
                </div>
            `;
    cargarTiendas(modal.querySelector('select[name="tienda"]'));
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    // Evitar scroll de fondo mientras el modal está abierto
    document.body.style.overflow = 'hidden';
    // cerrar si se hace click fuera del cuadro
    modal.onclick = closeTradeInModal;
    // permitir cerrar con Escape
    modal._escHandler = function (e) { if (e.key === 'Escape') closeTradeInModal(); };
    document.addEventListener('keydown', modal._escHandler);
    // Manejar envío del formulario dentro del modal
    const form = document.getElementById('tradeInForm');
    form.onsubmit = async function (e) {
        e.preventDefault();

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        // Validación adicional para teléfono: solo dígitos
        const telEl = form.querySelector('input[name="telefono"]');
        if (telEl) {
            const telVal = (telEl.value || '').trim();
            if (!/^\d+$/.test(telVal)) {
                telEl.setCustomValidity('El teléfono solo puede contener números');
                telEl.reportValidity();
                return;
            }
            telEl.setCustomValidity('');
        }
        const ibanEl = form.querySelector('input[name="iban"]');
        if (ibanEl) {
            const ibanVal = (ibanEl.value || '').trim();
            if (ibanVal && !ibanLongitudValida(ibanVal)) {
                ibanEl.setCustomValidity('El IBAN no tiene una longitud válida');
                ibanEl.reportValidity();
                return;
            }
            ibanEl.setCustomValidity('');
        }
        const data = Object.fromEntries(new FormData(form).entries());
        await enviarATiendaConFormulario(data);
    };
    // Forzar que el campo teléfono solo permita entrada numérica (elimina caracteres no numéricos en tiempo real)
    const telefonoInput = modal.querySelector('input[name="telefono"]');
    if (telefonoInput) {
        telefonoInput.addEventListener('input', (ev) => {
            const cleaned = ev.target.value.replace(/\D+/g, '');
            if (ev.target.value !== cleaned) ev.target.value = cleaned;
            ev.target.setCustomValidity('');
        });
    }
    const ibanInput = modal.querySelector('input[name="iban"]');
    if (ibanInput) {
        ibanInput.addEventListener('input', (ev) => {
            ev.target.setCustomValidity('');
        });
    }
    // Mostrar campo factura solo si se selecciona 'envio'
    const facturaWrapper = modal.querySelector('#facturaField');
    const envioRadio = modal.querySelector('#envio');
    const entregaRadio = modal.querySelector('#entregaTienda');
    function toggleFactura() {
        if (!facturaWrapper) return;
        const camposEnvio = facturaWrapper.querySelectorAll('input, select, textarea');
        if (envioRadio && envioRadio.checked) {
            facturaWrapper.style.display = '';
            camposEnvio.forEach((campo) => {
                campo.required = true;
                campo.disabled = false;
                campo.setCustomValidity('');
            });
        } else {
            facturaWrapper.style.display = 'none';
            camposEnvio.forEach((campo) => {
                campo.required = false;
                campo.disabled = true;
                campo.value = '';
                campo.setCustomValidity('');
            });
        }
    }
    if (envioRadio) envioRadio.addEventListener('change', toggleFactura);
    if (entregaRadio) entregaRadio.addEventListener('change', toggleFactura);
    // Estado inicial
    toggleFactura();
    // Radios son mutuamente excluyentes por defecto; no se requieren listeners adicionales.
}

function closeTradeInModal(event) {
    if (event) event.stopPropagation();
    const modal = document.getElementById('tradeInModal');
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    // Restaurar scroll de fondo
    document.body.style.overflow = '';
    // limpiar handlers
    if (modal._escHandler) document.removeEventListener('keydown', modal._escHandler);
    modal.onclick = null;
    setTimeout(() => { modal.innerHTML = ''; }, 220);
}

async function enviarATiendaConFormulario(data) {
    const payload = {
        nombre: data.nombre || '',
        dni: data.dni || '',
        email: data.email || '',
        telefono: data.telefono || '',
        tienda: data.tienda || '',
        tradeinOption: data.tradeinOption || '',
        factura: data.factura || '',
        direccion: data.direccion || '',
        codigoPostal: data.codigoPostal || '',
        iban: data.iban || '',
        precioCotizado: data.precioCotizado || '',
        monedaCotizada: data.monedaCotizada || '',
        modelo: dispositivoSeleccionado && dispositivoSeleccionado.ItemName ? dispositivoSeleccionado.ItemName : '',
        imei: dispositivoSeleccionado && dispositivoSeleccionado.Identifier ? dispositivoSeleccionado.Identifier : ''
    };

    try {
        const resp = await fetch('https://n8n.rossellimac.info/webhook/test-email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!resp.ok) {
            throw new Error('HTTP ' + resp.status);
        }

        closeTradeInModal();
        showGlobalMessage('Tu solicitud de Trade-In ha sido registrada. Nos pondremos en contacto contigo pronto.', 'success');
    } catch (err) {
        console.error('Error enviando formulario a n8n', err);
        showGlobalMessage('Hubo un error al enviar tu solicitud. Por favor, inténtalo de nuevo más tarde.', 'error');
    }
}

function cerrarImagen(event) {
    if (event) event.stopPropagation();
    document.getElementById('modal').style.display = 'none';
}

// Muestra un mensaje dentro de la sección y lo oculta automáticamente.
function showGlobalMessage(msg, type = 'success') {
    const container = document.querySelector('.container');
    if (!container) return;

    if (type === 'success') {
        container.innerHTML = '';
        container.style.display = 'flex';
        container.style.flexDirection = 'column';
        container.style.alignItems = 'center';
        container.style.justifyContent = 'center';
        container.style.textAlign = 'center';
        container.style.minHeight = '320px';

        const box = document.createElement('div');
        box.style.maxWidth = '720px';
        box.style.width = '100%';
        box.style.background = '#fff';
        box.style.borderRadius = '12px';
        box.style.padding = '28px';
        box.style.boxShadow = '0 6px 30px rgba(0,0,0,0.08)';

        const h = document.createElement('h2');
        h.innerText = 'Gracias por confiar en Rossellimac';
        h.style.margin = '0 0 10px 0';
        h.style.color = '#116632';

        const p = document.createElement('p');
        p.innerText = msg;
        p.style.margin = '0';
        p.style.fontSize = '1.05rem';

        box.appendChild(h);
        box.appendChild(p);
        container.appendChild(box);

        setTimeout(() => { container.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 60);
        return;
    }

    const prev = document.getElementById('globalMessage');
    if (prev) prev.remove();
    const div = document.createElement('div');
    div.id = 'globalMessage';
    div.style.marginTop = '12px';
    div.style.padding = '12px 14px';
    div.style.borderRadius = '8px';
    div.style.fontWeight = '600';
    if (type === 'success') {
        div.style.background = '#e8f8ee';
        div.style.color = '#116632';
        div.style.border = '1px solid #c7efd3';
    } else {
        div.style.background = '#fff4f4';
        div.style.color = '#8a1717';
        div.style.border = '1px solid #f3c4c4';
    }
    div.innerText = msg;
    container.insertBefore(div, container.firstChild);
    // hacer scroll al mensaje
    setTimeout(() => { div.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 60);
    // auto-dismiss
    setTimeout(() => { if (div && div.parentNode) div.parentNode.removeChild(div); }, 7000);
}